import { Utilities } from "s2s-app-service";
import { addLocaleData } from "react-intl";
import Messages from "../js/messages";
import { useStore } from '../js/store';

let dialect, messages, localeData;

dialect = 'en';

messages = (new Messages(dialect)).getAllMessages();

// inject onto utilities
Utilities.getInstance().setIntlMessages(messages);
// needed for INTL
localeData = require('react-intl/locale-data/' + dialect);

addLocaleData(localeData);

const initialState = {
  "locale": dialect,
  "messages": messages,
};

const useLocale = () => {
  const [state, setState] = useStore();

  const setDialect = (newDialect) => setState(old => {
       
    // build new so we can addLocaleData
    const newLocaleData = require('react-intl/locale-data/' + newDialect);
    addLocaleData(newLocaleData);
    const newMessages = (new Messages(newDialect)).getAllMessages();
    Utilities.getInstance().setIntlMessages(newMessages);

    // return new stuff ... objectMerge might be better
 
    return ({
      ...old,
      "locale": {"messages": newMessages, "locale": newDialect }
    });
  });

  const lReturn = state !== undefined && state.locale ? state.locale : initialState;

  return [lReturn, { setDialect }];
};

export default useLocale;
export { initialState };




